import React, { useEffect, useState } from 'react'
import './Navbar.css';

function Navbar() {

    const [show, handleShow] = useState(false);

useEffect(() => {
   window.addEventListener('scroll', () => {
       window.scrollY > 100 ? handleShow(true) : handleShow(false)
   });
   return () => {
       window.removeEventListener('scroll')
   }
}, [])

    return (
        <div className={`navbar ${show && 'navbar__black'}`}>
            <img src="https://upload.wikimedia.org/wikipedia/commons/0/0f/Logo_Netflix.png" alt="Netflix logo" className="navbar__logo"/>

            <img src="https://pbs.twimg.com/profile_images/1240119990411550720/hBEe3tdn_400x400.png" alt="Netflix logo" className="navbar__avatar"/>
        </div>
    )
}

export default Navbar
